// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"03c50fdd","493":"4e748b02","981":"627480db"}[chunkId] + ".css";
};